class PackVariantRadios extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);
  }

  connectedCallback() {
    this.productGroups = Array.from(this.querySelectorAll('[js-pack-product]'));
    this.addEventListener('change', this.onVariantChange);
    this.updateSelections();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    if (!event.target.matches('.js-get-pack-variant')) return;
    this.updateSelections();
  }

  getSelections() {
    return this.productGroups.map((group) => {
      const variants = this.getVariantData(group);
      const selectedOptions = this.getSelectedOptions(group);
      const variant = this.matchVariant(variants, selectedOptions);
      return {
        productId: group.dataset.productId,
        handle: group.dataset.productHandle,
        packPrice: group.dataset.packPrice,
        options: selectedOptions,
        variant,
      };
    });
  }

  // Array indexado por (position - 1) para que coincida con variant.options
  getSelectedOptions(group) {
    const result = [];
    group.querySelectorAll('select.js-get-pack-variant').forEach((select) => {
      const position = parseInt(select.dataset.position, 10);
      result[position - 1] = select.value || null;
    });
    return result;
  }

  getVariantData(group) {
    const el = group.querySelector('[js-pack-variant-data]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('PackVariantRadios: data de variantes inválida', e);
      return [];
    }
  }

  matchVariant(variants, selectedOptions) {
    return variants.find((variant) =>
      selectedOptions.every((value, index) =>
        value == null ? true : variant.options[index] === value
      )
    );
  }

  updateSelections() {
    this.selections = this.getSelections();

    this.selections.forEach((selection) => {
      const group = this.productGroups.find(
        (g) => g.dataset.productId === selection.productId
      );
      if (!group) return;

      const hidden = group.querySelector('[js-pack-selected-variant]');
      if (hidden && selection.variant) hidden.value = selection.variant.id;

      this.updateAvailability(group);
    });

    // Sincroniza la data del pack en los botones de add to cart
    this.updatePackButtons();

    this.dispatchEvent(
      new CustomEvent('pack:variant-change', {
        bubbles: true,
        detail: { selections: this.selections },
      })
    );
  }

  // Escribe las variantes seleccionadas (con weight, price, quantity, variantId)
  // en data-product-pack de los botones de add to cart
  updatePackButtons() {
    const items = this.selections
      .filter((s) => s.variant)
      .map((s) => {
        const packPrice = parseInt(s.packPrice, 10);
        return {
          variantId: s.variant.id,
          sku: s.variant.sku,
          weight: s.variant.weight,
          price: packPrice,
          quantity: 1,
        };
      });

    const json = JSON.stringify(items);

    // ¿Todas las variantes seleccionadas del pack están disponibles?
    const allAvailable =
      this.selections.length > 0 &&
      this.selections.every((s) => s.variant && s.variant.available);

    // ¿Todos los productos del pack tienen un precio configurado en el metacampo?
    const pricesConfigured = this.selections.every((s) => {
      const p = parseInt(s.packPrice, 10);
      return !Number.isNaN(p);
    });

    const canPurchase = allAvailable && pricesConfigured;

    document.querySelectorAll('.js-add-product-template').forEach((btn) => {
      btn.setAttribute('data-product-pack', json);

      if (!canPurchase) {
        btn.disabled = true;
        btn.setAttribute('data-pack-unavailable', '');
        btn.classList.add('c-button--disabled', 'unavailable');

        const textEl = btn.querySelector('.text-of__btn');
        if (textEl) textEl.textContent = 'Agotado';
      } else if (btn.hasAttribute('data-pack-unavailable')) {
        btn.disabled = false;
        btn.removeAttribute('data-pack-unavailable');
        btn.classList.remove('c-button--disabled', 'unavailable');

        const textEl = btn.querySelector('.text-of__btn');
        if (textEl) {
          const original = textEl.dataset.notDisabled;
          if (original) textEl.textContent = original;
        }
      }
    });
  }

  // Deshabilita las <option> que no existen para la combinación actual de ese producto
  updateAvailability(group) {
    const variants = this.getVariantData(group);
    const base = this.getSelectedOptions(group);

    group.querySelectorAll('select.js-get-pack-variant').forEach((select) => {
      const index = parseInt(select.dataset.position, 10) - 1;

      Array.from(select.options).forEach((opt) => {
        const candidate = [...base];
        candidate[index] = opt.value;

        const available = variants.some(
          (variant) =>
            variant.available &&
            candidate.every((value, i) => value == null || variant.options[i] === value)
        );

        opt.disabled = !available;
      });
    });
  }
}

customElements.define('pack-variant-radios', PackVariantRadios);